<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="交易单号" prop="transaction">
                <a-input v-model="queryParam.transaction" placeholder="请输入交易单号" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单号" prop="order">
                <a-input v-model="queryParam.order" placeholder="请输入订单号" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <template >
              <a-col :md="8" :sm="24">
                <a-form-item label="支付方式" prop="type">
                  <a-select v-model="queryParam.type">
                    <a-select-option :value="0">余额</a-select-option>
                    <a-select-option :value="1">微信</a-select-option>
                    <a-select-option :value="2">支付宝</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否结算" prop="isPay">
                  <a-select v-model="queryParam.isPay">
                    <a-select-option :value="false">否</a-select-option>
                    <a-select-option :value="true">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否对账" prop="isAccounts">
                  <a-select v-model="queryParam.isAccounts">
                    <a-select-option :value="false">否</a-select-option>
                    <a-select-option :value="true">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="结算单号" prop="payNumber">
                  <a-input v-model="queryParam.payNumber" placeholder="请输入学院结算金额" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="创建区间时间" prop="data">
                  <a-range-picker format="YYYY-MM-DD 00:00:00" @change="onChange" v-model="date"/>
                </a-form-item>
              </a-col>


<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否结算 " prop="isPay">-->
<!--                  <a-input v-model="queryParam.isPay" placeholder="请输入是否结算 " allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否完成对账" prop="isAccounts">-->
<!--                  <a-input v-model="queryParam.isAccounts" placeholder="请输入是否完成对账" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- <div class="table-operations"> -->
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['account:account:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['account:account:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['account:account:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['account:account:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div> -->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['account:account:edit']">
            <a-icon type="file" />查看详情
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['account:account:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['account:account:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAccount,listAccount, delAccount } from '@/api/account/account'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Account',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      date: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        transaction: null,
        order: null,
        name: null,
        payNumber: null,
        courseName: null,
        mobile: null,
        courseType: null,
        sysMobile: null,
        sysName: null,
        type: null,
        orderMoney: null,
        schoolMoney: null,
        isPay: null,
        isAccounts: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '创建人',
          dataIndex: 'sysName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建人手机号',
          dataIndex: 'sysMobile',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '购买人姓名',
        //   dataIndex: 'name',
        //   ellipsis: true,
        //   align: 'center'
        // },
        //
        // {
        //   title: '购买人手机号',
        //   dataIndex: 'mobile',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '课程名称',
        //   dataIndex: 'courseName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '课程类型',
        //   dataIndex: 'courseType',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender(f){
        //     if(f == 2){
        //       return '创作者课程'
        //     } else if(f == 0){
        //       return '健身课程'
        //     } else {
        //       return '学院课程'
        //     }
        //   }
        // },
        {
          title: '交易单号',
          dataIndex: 'transaction',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'order',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支付方式 ',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return '微信'
            }
            else if(f ==2){
              return '支付宝'
            }
            else  if(f ==0){
              return '余额'
            }
          }
        },
        {
          title: '订单金额',
          dataIndex: 'orderMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '学院分润',
          dataIndex: 'schoolMoney',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '是否结算 ',
        //   dataIndex: 'isPay',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender(f){
        //     if(f == 0){
        //       return '未结算'
        //     }
        //     else  {
        //       return '结算'
        //     }
        //   }
        // },
        {
          title: '对账',
          dataIndex: 'isAccounts',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 0){
              return '未对账'
            }
            else  {
              return '已对账'
            }
          }
        },
        {
          title: '交易时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width:150

        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  activated () {
    this.queryParam.payNumber = this.$route.query.payNumber
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询结算流水列表 */
    getList () {
      this.loading = true
      //时间筛选
      if(this.date){
        if(this.date[0]){
          this.queryParam.createBeginTime= this.date[0]
        }
        if(this.date[1]){
          this.queryParam.createEndTime= this.date[1]
        }
        console.log(this.queryParam.createBeginTime,this.queryParam.createEndTime)
      }
     pageAccount(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    onChange(date, dateString) {
      this.date = dateString;
    },
  

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        transaction: undefined,
        payNumber: undefined,
        order: undefined,
        type: undefined,
        name: undefined,
        courseName: undefined,
        courseType: undefined,
        sysMobile: undefined,
        sysName: undefined,
        mobile: undefined,
        orderMoney: undefined,
        schoolMoney: undefined,
        isPay: undefined,
        isAccounts: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delAccount(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('account/account/export', {
            ...that.queryParam
          }, `结算流水_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
